/* Publish by EComposer at 2026-11-03 11:23:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-s2jti1wb8re"]=  window.__ectimmers["ecom-s2jti1wb8re"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-s2jti1wb8re').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-s2jti1wb8re', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-s2jti1wb8re', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gqifo3t8ee').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gqifo3t8ee', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gqifo3t8ee', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nv54fdpov1f').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nv54fdpov1f', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nv54fdpov1f', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ryt6ox159nb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ryt6ox159nb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ryt6ox159nb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vssokh3n3ul').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vssokh3n3ul', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vssokh3n3ul', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ompv29rw74').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ompv29rw74', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ompv29rw74', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-it41d3jz8p"]=  window.__ectimmers["ecom-it41d3jz8p"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-it41d3jz8p"]["b49q2u7yl"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-it41d3jz8p').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-it41d3jz8p', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-it41d3jz8p', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hsdhazpk4jn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hsdhazpk4jn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hsdhazpk4jn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-77k6p5zm9w7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-77k6p5zm9w7', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-77k6p5zm9w7', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wslp82cthfb"]=  window.__ectimmers["ecom-wslp82cthfb"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-wslp82cthfb"]["32wjxykpd"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-wslp82cthfb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wslp82cthfb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wslp82cthfb', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}